export const localState0 = {
  prodAdmin: {
    hostname: "localhost",
    phoneNumber: "04065662",
    login: "ahmed_fayyaz@outlook.com",
    password: "p123456",
    envName: "prod"
  },
  prodStore: {
    hostname: "localhost",
    phoneNumber: "94562450",
    login: "supp1@bcs.com",
    password: "p123456",
    envName: "prod"
  },
  prodWorker: {
    hostname: "localhost",
    phoneNumber: "97861234",
    login: "",
    password: "",
    envName: "prod"
  },
  prodBlank: {
    hostname: "localhost2",
    phoneNumber: "",
    login: "",
    password: "",
    envName: "prod"
  },
  devAdmin: {
    hostname: "localhost",
    phoneNumber: "04065662",
    login: "ahmed_fayyaz@outlook.com",
    password: "p123456",
    envName: "dev"
  },
  devStore: {
    hostname: "localhost",
    phoneNumber: "00002450",
    login: "supp1@bcs.com",
    password: "devpass",
    envName: "dev"
  },
  devWorker: {
    hostname: "localhost",
    phoneNumber: "98761234",
    login: "ismita@bcs.com.sg",
    password: "p123456",
    envName: "dev"
  },
  devBlank: {
    hostname: "localhost",
    phoneNumber: "",
    login: "",
    password: "",
    envName: "dev"
  }
};



// WEBPACK FOOTER //
// ./src/staticData/localState0.js